<template>
    <div class="deposits-info">
        <h2 class="h2">Полезная информация</h2>
        <UITabs
            :tabs="tabsData"
            :current-tab="currentTab"
            theme="monochrome"
            variant="filled"
            class="deposits-info-tabs"
        >
            <template #docs>
                <ul class="text text-light deposits-info-docs">
                    <li
                        v-for="(document) in documents"
                        :key="document.id"
                        class="deposits-info-docs__item"
                    >
                        <button
                            :class="[
                                'deposits-info-docs__button',
                                {'deposits-info-docs__button--opened': checkListVisibility(document.id)}
                            ]"
                            @click="toggleDocsList(document.id)"
                        >
                            {{ document.title }}
                            <ChevronSvg />
                        </button>
                        <transition name="fade">
                            <div v-show="checkListVisibility(document.id)">
                                <ul v-if="document.docs && document.docs.length">
                                    <li
                                        v-for="(doc, index) in document.docs"
                                        :key="doc"
                                        class="mt-8"
                                        v-html="`${++index}. ${doc}`"
                                    />
                                    <ul
                                        v-if="document.appendix && document.appendix.length"
                                        class="deposits-info-docs__list"
                                    >
                                        <li
                                            v-for="item in document.appendix"
                                            :key="item"
                                            class="fz-14"
                                            v-html="item"
                                        />
                                    </ul>
                                    <template v-if="document.note && document.note.length">
                                        <p
                                            v-for="item in document.note"
                                            :key="item"
                                            class="mt-8 fz-14"
                                            v-html="item"
                                        />
                                    </template>
                                </ul>
                            </div>
                        </transition>
                    </li>
                </ul>
            </template>
            <template #references>
                <UIDocument
                    v-for="({label, link}) in depositsTemplates"
                    :key="link"
                    :label="label"
                    :link="link"
                    class="deposits-info-document"
                />
                <UIDocument
                    v-for="({label, link}) in depositsDoc"
                    :key="link"
                    :label="label"
                    :link="link"
                    class="deposits-info-document"
                />
            </template>
            <template #prolongations>
                <UITable
                    class="deposits-info-prolongations"
                    :table-data="rubProlongationsTableData"
                />
            </template>
        </UITabs>
    </div>
</template>

<script>
import {computed, defineComponent, nextTick, ref} from 'vue';
import {useContext} from '@nuxtjs/composition-api';
import {UITable, UIDocument} from '@cibsite/ui-components-vue2';

import {addIdToArrayObjects} from '@/core/utils/addIdToArrayObjects';
import UITabs from '@/components/UI-components/Tabs/UITabs';

export default defineComponent({
    name: 'DepositsInfo',
    components: {
        UITabs,
        UITable,
        UIDocument,
        ChevronSvg: () => import('@/assets/images/icons/arrows/chevron-down-bold.svg?inline'),
    },
    props: {
        tabsData: {
            type: Array,
            required: true,
        },
        currentTab: {
            type: Number,
            default: () => 0,
        },
        infoDocs: {
            type: Array,
            required: true,
        },
        depositsTemplates: {
            type: Array,
            required: true,
        },
        depositsDoc: {
            type: Array,
            default: () => [],
        },
        rubProlongationsTableData: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const {$isMobileOrTablet} = useContext();

        const visibleDocs = ref([]);

        const documents = computed(() => {
            return addIdToArrayObjects(props.infoDocs);
        });

        function toggleDocsList(documentId) {
            if (!checkListVisibility(documentId)) {
                visibleDocs.value.push(documentId);

                return;
            }

            const index = visibleDocs.value.indexOf(documentId);
            visibleDocs.value.splice(index, 1);
        }

        async function checkListVisibility(id) {
            if (!$isMobileOrTablet) {
                return true;
            }

            await nextTick();

            return visibleDocs.value?.includes(id);
        }

        return {
            visibleDocs,
            documents,
            toggleDocsList,
            checkListVisibility,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/for-individuals/deposits/deposits-info';
</style>
